import { isUndefined } from 'lodash';
import { getTimeRemaining } from '../../utils';
import Icon from '../icons';

const trophyIcon = Icon({
  type: 'trophy',
  color: 'rgb(245, 212, 85)',
  size: 16,
});
const trophyIconSmall = Icon({
  type: 'trophy',
  color: 'rgb(245, 212, 85)',
  size: 14,
});
const clockIcon = Icon({ type: 'clock', color: '#848d9e', size: 16 });
const clockIconSmall = Icon({ type: 'clock', color: '#848d9e', size: 14 });
const hotIcon = Icon({ type: 'hot', color: '#ffffff', size: 8 });

class Homescreen {
  constructor() {
    this.getText = Pollfish.ui.getText;
  }

  startOfferCountdown = () => {
    const {
      reward_offer_expiration: rewardOfferExpiration,
    } = Pollfish.helper.json;
    this.timer = setInterval(() => {
      const bannerElement = $('#js-offer-banner');
      const rewardsElement = $('#js-offer-rewards');
      const time = getTimeRemaining(rewardOfferExpiration);
      const timeLeft = time.total;
      bannerElement.html(this.renderOfferBanner());
      rewardsElement.html(this.renderRewards());
      // Since is not easy to clearInterval on "Take survey" click event
      // and is not safe to leave the interval as a leak
      // if the banner or offer reward element is not in DOM we should clear the interval
      if (
        timeLeft < 0 ||
        bannerElement.length === 0 ||
        !rewardsElement.length === 0
      ) {
        this.clearTimer();
      }
    }, 1000);
  };

  clearTimer = () => {
    clearInterval(this.timer);
  };

  renderHeader = () => {
    const { getText } = this;
    const surveyLOI = this.getSurveyLOI();

    let title = getText('surveyPromptNoIncentive', surveyLOI);
    title = Pollfish.helper.is3rdParty()
      ? title.replace(/<span.*<\/span>/g, '')
      : title;
    return title;
  };

  getSurveyLOI = () => {
    let { survey_loi: surveyLOI } = Pollfish.helper.json;

    // for safety https://pollfish.atlassian.net/browse/PUB-1794
    if (isUndefined(surveyLOI)) {
      ({ surveyLOI } = Pollfish.helper);
    }

    // since we no longer have survey_loi available on some cases,
    // and the preprocess of the survey does not work since we have no questions to show
    // we show a default "max" LOI until we solve it, so that we don't hide the loi completely
    return surveyLOI || 4;
  };

  renderImg = () => {
    // incentive was the amazon gift cards that have been deprecated
    let type = 'non-incentive';

    let imgEl = `
      <div class="card__image card__image--no-margin card__image--${type}">
        <div class="card__image-svg card__image-svg--${type}"></div>
      </div>
    `;

    if (Pollfish.helper.json.theme_logo) {
      type = 'custom-logo';
      imgEl = `
        <div class="card__image card__image--no-margin card__image--${type}">
          <img src="${Pollfish.helper.json.theme_logo}" alt="" style="max-height: 160px; max-width: 100%;" />
        </div>
      `;
    }

    return imgEl;
  };

  renderOfferBanner = () => {
    const {
      reward_offer_enabled: rewardOfferEnabled,
      reward_offer_expiration: rewardOfferExpiration,
      reward_offer_multiplier: rewardOfferMultiplier,
    } = Pollfish.helper.json;

    if (!rewardOfferEnabled) {
      return '';
    }

    const { text } = getTimeRemaining(rewardOfferExpiration);

    return `
      <p class="flex flex-align-items--center flex-1 flex-justify--center" style="padding: 4px 0; background-color: #fb3b71; color: white;">
        <span class="line-height-reset" style="margin-bottom: 2px;">${hotIcon}</span>
        <span class="text-xs" style="margin-left: 3px;"><b>${rewardOfferMultiplier}x ${this.getText(
      'schedule_offer.rewards',
    )}</b> (${this.getText('schedule_offer.offer_ends')}: <b>${text}</b>)</span>
      </p>
    `;
  };

  render3dParty = () => {
    const { getText } = this;
    let content = '';

    if (Pollfish.helper.is3rdParty() && !Pollfish.helper.opensInWebview()) {
      content = `
        <div class="text-sm text-lighter margin-xl-top opens-in-browser">
          ${getText('opens_in_browser')}
        </div>
      `;
    } else {
      content = `
        <div class="text-sm text-light margin-xl-top opens-in-browser font-bold">
          ${getText('anonymous_responses')}
        </div>
      `;
    }

    return content;
  };

  renderRewards = () => {
    const {
      reward_settings_enabled: rewardsEnabled,
      reward_name: rewardName,
      reward_value: rewardValue,
      reward_offer_enabled: rewardOfferEnabled,
      reward_offer_multiplier: rewardOfferMultiplier,
      reward_offer_expiration: rewardOfferExpiration,
      reward_offer_previous_value: rewardOfferPreviousValue,
    } = Pollfish.helper.json;

    const surveyLOI = this.getSurveyLOI();
    // we always show LOI even if no rewards are enabled
    if (!rewardsEnabled || !rewardName || !rewardValue) {
      return `
        <div>
          <p class="flex flex-align-items--center flex-1 flex-justify--center">
            <span class="margin-sm-left line-height-reset">${clockIcon}</span>
            <span class="font-bold" style="margin-left: 3px;">${surveyLOI}'</span>
          </p>
        </div>
      `;
    }

    // we show offer rewards when offer is active
    if (
      rewardOfferEnabled &&
      rewardOfferMultiplier &&
      rewardOfferExpiration &&
      rewardOfferPreviousValue
    ) {
      return `
        <div class="flex flex-column flex-align-items--center">
          <div class="flex flex-justify--center margin-xxs-btm">
            <div class="flex flex-align-items--center" style="border-radius: 20px; background-color: #eef3f7; padding: 0 6px;">

              <span class="text-xs" style="text-decoration: line-through;">${rewardOfferPreviousValue}</span>
              <span class="font-bold" style="font-size: 14px; margin-left: 3px;">${rewardValue}</span>
            </div>
          </div>
          <p class="flex flex-align-items--center flex-1 flex-justify--center" style="margin-bottom: 14px;">
            <span class="line-height-reset">${trophyIconSmall}</span>
            <span class="font-bold margin-xxs-left" style="font-size: 14px;">${rewardName}</span>
          </p>
          <p class="flex flex-align-items--center flex-1 flex-justify--center">
            <span class="line-height-reset">${clockIconSmall}</span>
            <span class="font-bold" style="font-size: 14px; margin-left: 3px;">${surveyLOI}'</span>
          </p>
        </div>
      `;
    }

    return `
      <div>
        <p class="flex flex-align-items--center flex-1 flex-justify--center">
          <span class="line-height-reset">${trophyIcon}</span>
          <span style="margin-left: 3px" class="font-bold">${rewardValue}</span>
          <span class="margin-xxs-left">${rewardName}</span>
          <span class="margin-sm-left line-height-reset">${clockIcon}</span>
          <span class="font-bold" style="margin-left: 3px;">${surveyLOI}'</span>
        </p>
      </div>
    `;
  };

  renderAcceptanceInfo = () => {
    const { getText } = this;
    let text = getText('by_accepting_this_survey');
    if (Pollfish.helper.isAndroid() && Pollfish.helper.json.sdk_version < 34) {
      text = getText('android_notification');
    }
    const content = `
      <p class="text-xs text-light google-indicator margin-xl-btm">
        ${text}
      </p>
    `;

    return content;
  };

  renderWithdrawConsent = () => {
    let content = '';
    const { getText } = this;
    if (Pollfish.helper.isDistributionLink()) {
      return content;
    }

    if (Pollfish.helper.hasAcceptedTerms()) {
      content = `
        <span class="horizontal-separator">/</span>
        <a href="#" class="js-withdraw-consent link-theme-hover">${getText(
          'withdraw_consent',
        )}</a>
      `;
    }

    return content;
  };

  renderNoThanks = () => {
    const { getText } = this;
    return `
      <div class="margin-xl-top">
        <a href="#" class="btn btn-xs btn-flat js-survey-reject-btn link-theme-hover">
          ${getText('no_thanks')}
        </a>
      </div>
    `;
  };

  renderTerms = () => {
    const { getText } = this;
    const text = getText('by_taking_survey');
    return `${text} <a href="#" class="js-terms link-theme-hover">${getText(
      'notify_terms',
    )}</a>`;
  };

  shouldStartOfferCountdown = () => {
    const {
      reward_offer_enabled: rewardOfferEnabled,
      reward_offer_multiplier: rewardOfferMultiplier,
      reward_offer_expiration: rewardOfferExpiration,
      reward_offer_previous_value: rewardOfferPreviousValue,
    } = Pollfish.helper.json;

    return Boolean(
      rewardOfferEnabled &&
        rewardOfferMultiplier &&
        rewardOfferExpiration &&
        rewardOfferPreviousValue,
    );
  };

  render() {
    if (this.shouldStartOfferCountdown() && !this.timer) {
      this.startOfferCountdown();
    }
    const { getText } = this;
    return `
      <div class="main-content__home">
        <h1 class="header-text">${this.renderHeader()}</h1>
        <div class="homescreen-card">
          <div class="card__header">
            ${this.renderImg()}
            <div id="js-offer-banner">
              ${this.renderOfferBanner()}
            </div>
          </div>
          <div class="card__content">
            <div id="js-offer-rewards" class="margin-lg-top margin-lg-btm">
            ${this.renderRewards()}
            </div>
            <div class="margin-lg-top">
              <a href="#" id="take-survey-btn" class="btn btn-primary btn-lg js-take-survey-btn">
                ${getText('take_survey_btn')}
              </a>
            </div>
            ${this.render3dParty()}
            ${this.renderAcceptanceInfo()}
          </div>
        </div>
        ${Pollfish.helper.shouldHideNoThanks() ? '' : this.renderNoThanks()}
      </div>
      <div class="footer">
        <p class="text-sm text-light footer__terms">
          ${this.renderTerms()}
          ${this.renderWithdrawConsent()}
        </p>
      </div>`;
  }
}

export default Homescreen;
